import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const column1 = ['Aprender oficios rentables desde cero', 'Crear productos que se venden todo el año', 'Generar ingresos extra reparando, fabricando o vendiendo', 'Trabajar con seguridad y sin errores', 'Ahorrar tiempo con planos listos y pasos claros', 'Sentirte más seguro, capaz y productivo con tus manos'];
  const column2 = ['Hombres que quieren aprender un oficio real', 'Quienes buscan generar ingresos con sus manos', 'Personas cansadas del sueldo que no alcanza', 'Emprendedores que quieren fabricar y vender desde casa', 'Principiantes que necesitan guías simples y explicadas'];
  return <section className="bg-gray-50 py-5 md:py-16 px-4" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 mb-5 md:mb-10" data-id="element-177">
          {/* Column 1 */}
          <div className="bg-white rounded-2xl p-4 md:p-8 shadow-lg border border-gray-100" data-id="element-178">
            <h3 className="text-2xl font-bold text-[#f97316] mb-3 md:mb-6 flex items-center gap-3" data-id="element-179">
              <span className="text-3xl" data-id="element-180">⚡</span> ¿Qué resultados vas a
              conseguir?
            </h3>
            <ul className="space-y-2 md:space-y-4" data-id="element-181">
              {column1.map((result, index) => <li key={index} className="flex items-start gap-3" data-id="element-182">
                  <div className="bg-orange-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-183">
                    <Check className="w-4 h-4 text-[#f97316]" strokeWidth={3} data-id="element-184" />
                  </div>
                  <span className="text-gray-700 text-lg" data-id="element-185">{result}</span>
                </li>)}
            </ul>
          </div>

          {/* Column 2 */}
          <div className="bg-white rounded-2xl p-4 md:p-8 shadow-lg border border-gray-100" data-id="element-186">
            <h3 className="text-2xl font-bold text-gray-900 mb-3 md:mb-6 flex items-center gap-3" data-id="element-187">
              <span className="text-3xl" data-id="element-188">👷‍♂️</span> ¿Para quién es este Mega
              Pack?
            </h3>
            <ul className="space-y-2 md:space-y-4" data-id="element-189">
              {column2.map((result, index) => <li key={index} className="flex items-start gap-3" data-id="element-190">
                  <div className="bg-orange-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-191">
                    <Check className="w-4 h-4 text-[#f97316]" strokeWidth={3} data-id="element-192" />
                  </div>
                  <span className="text-gray-700 text-lg font-medium" data-id="element-193">
                    {result}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-194">
          <CTAButton onClick={scrollToPricing} className="px-8 py-4 text-lg md:text-xl" data-id="element-195">
            QUIERO ESTOS RESULTADOS AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}